
import { Toast, PullRefresh, SwipeCell, Dialog, Badge, Field } from "vant";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { BoxPayGrade, CheckUser } from "@/req/pay"
import NavBar from "@/components/navBar.vue"
import payPopup from "./components/payPopup.vue"
@Component({
  components: {
    NavBar,
    payPopup
  },
})
export default class Logout extends Vue {
  public initial = "";
  public money: any = "";
  public uid = null;
  public practicalMoney: any = 0;
  public disabled = false;
  public activeId = null;
  public nickName = this.$store.state.user.info.nick_name;
  public account = this.$store.state.user.info.phone;
  public accountImgShow = true;
  public isShowPayPopup = false;
  public payData = []
  public accountList = [];
  public imgAccount = false;
  public btnActive = false;
  public saveFlag = 0;
  public products: any = [];
  public mounted() {
    const $boxCoinPay = this.$refs.boxCoinPay as any;
    $boxCoinPay.style.height = $boxCoinPay.offsetHeight + "px";
    this.getBoxPayGrade();
    this.accountRecord();
  }
  @Watch("practicalMoney")
  public practicalMoneyChange(val) {
    if (val == "") {
      this.btnActive = false;
    } else {
      this.btnActive = true;
    }
  }

  public async getBoxPayGrade() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
    };
    const res = await BoxPayGrade(obj);
    this.payData = res.data.pay_grade;
  }
  public boxMoney(val, id) {
    if (val >= 10000) {
      if (id == 1) {
        val = (val / 10000) + "万盒币"
      } else {
        val = (val / 10000).toFixed(1) + "万盒币"
      }
    } else {
      val = val + "盒币"
    }
    return val;
  }
  public practicalMoneys(val) {
    val = (val == "" ? 0 : val) + ".00"
    return val;
  }
  public onPayInput(val) {
    this.practicalMoney = val;
  }
  public onFocus() {
    this.accountImgShow = false;
  }
  public onBlur() {
    this.accountImgShow = true;
  }
  public activePayData(id, money) {
    this.activeId = id;
    this.practicalMoney = money;
  }
  // 充值账号效验
  public async onPayNow() {
    if (!this.btnActive) return Toast("充值金额不能为0");
    const obj = {
      token: this.$fn.cookies.getToken(),
      account: this.account
    }
    const res = await CheckUser(obj);
    if (res.code == 200) {
      this.uid = res.data.role_info.id;
      this.isShowPayPopup = true;
    }
  }
  public closePayPopup(event) {
    this.isShowPayPopup = event;
  }
  // 充值账号记录
  public accountRecord() {
    const arrList = [];
    const savePass = {
        head_img: this.$store.state.user.info.head_img,
        phone: this.$store.state.user.info.phone,
        nick_name: this.$store.state.user.info.nick_name
    };
    if (localStorage.getItem("boxPay") != null) {
      const tempObj = (JSON.parse as any)(localStorage.getItem("boxPay")); // localstorage转换
      tempObj.unshift(savePass);
      let len = tempObj.length;
      for (let i = 0; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if (tempObj[i].phone === tempObj[j].phone) {
            tempObj.splice(j, 1);
            j--; // 每删除一个数j的值就减1
            len--; // j值减小时len也要相应减1（减少循环次数，节省性能）
          }
        }
      }
      const saveObj = JSON.stringify(tempObj); // 数组转换存储
      localStorage.setItem("boxPay", saveObj);
    } else {
      (arrList as any).unshift(savePass);
      const saveObj = JSON.stringify(arrList);
      localStorage.setItem("boxPay", saveObj);
    }
    const boxPayObj = (JSON.parse as any)(localStorage.getItem("boxPay"));
    this.products = JSON.parse(JSON.stringify(boxPayObj));
  }
  // 充值账号切换
  public changeProducts(index) {
    this.products.map((item, ids) => {
      if (index === ids) {
        this.account = JSON.parse(JSON.stringify(item.phone));
        this.nickName = JSON.parse(JSON.stringify(item.nick_name))
      }
    });
    this.imgAccount = false;
    this.saveFlag = index;
  }
}
